export default __webpack_public_path__ + "static/media/poster-3.7cc21349.jpg";